module.exports = __webpack_public_path__ + "static/media/NowPlaying_Genesis.ff8cf7d3.png";